import { useTranslation } from "react-i18next";
import { useTheme } from "../../../theme/ThemeProvider";
import { OptionLabel } from "./OptionLabel";

export function ThemeMenuSection({ onSelect }: { onSelect?: () => void }) {
  const { t } = useTranslation();
  const { mode, setMode } = useTheme();

  return (
    <>
      <div className="topnav-dropdown__divider" />
      <div className="topnav-dropdown__heading">{t("common:nav.themeLabel")}</div>
      {(["light", "dark", "system"] as const).map((themeKey) => (
        <button
          key={themeKey}
          type="button"
          data-testid={`theme-option-${themeKey}`}
          className="topnav-menu-item"
          onClick={() => {
            setMode(themeKey);
            onSelect?.();
          }}
        >
          <OptionLabel active={mode === themeKey} label={t(`common:nav.theme.${themeKey}`)} />
        </button>
      ))}
    </>
  );
}
